const index = () => <div>index</div>;

export default index;
